<template>
  <div class="columns">
    <div class="column is-12 has-text-centered buttons is-multiline">
      <button class="button" @click="changementRapidePrevious()">
        <b-icon icon="chevron-double-left" size="is-small" type="is-default"></b-icon>
      </button>
      <button class="button" @click="previous">
        <b-icon icon="chevron-left" size="is-small" type="is-default"></b-icon>
      </button>
      <button class="button"
              v-for="(numberPage, index) in numbersPage"
              :key="index"
              @click="changeNumberPage(numberPage)"
              :class="[{ 'is-primary has-text-white':isActive === numberPage },
                { 'has-text-default' : isActive !== numberPage} ]"
      >
        {{ numberPage }}
      </button>
      <button class="button" @click="next">
        <b-icon icon="chevron-right" size="is-small" type="is-default"></b-icon>
      </button>
      <button class="button" @click="changementRapideNext()">
        <b-icon icon="chevron-double-right" size="is-small" type="is-default"></b-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralPagination',
  props: {
    firstNumber: Number,
    numberDisplay: Number,
  },
  data() {
    return {
      numbersPage: [],
      isActive: this.firstNumber,
    };
  },
  methods: {
    changementNumbersPage(firstValue) {
      let value = firstValue;
      this.numbersPage = [];
      for (let i = 0; i < this.numberDisplay; i += 1) {
        this.numbersPage.push(value);
        value += 1;
      }
    },
    next() {
      const index = this.numbersPage.findIndex(numberPage => numberPage === this.isActive);
      if (index !== this.numberDisplay - 1) {
        return this.changeNumberPage(this.numbersPage[index + 1]);
      }
      this.changementNumbersPage(this.numbersPage[0] + 1);
      return this.changeNumberPage(this.numbersPage[this.numberDisplay - 1]);
    },
    previous() {
      const index = this.numbersPage.findIndex(numberPage => numberPage === this.isActive);
      if (index !== 0) return this.changeNumberPage(this.numbersPage[index - 1]);
      this.changementNumbersPage(this.numbersPage[0] - 1);
      return this.changeNumberPage(this.numbersPage[0]);
    },
    changementRapideNext() {
      if (this.isActive === this.numbersPage[0]) {
        return this.changeNumberPage(this.numbersPage[this.numberDisplay - 1]);
      }
      const value = this.isActive + this.numberDisplay;
      this.numbersPage = [];
      for (let i = this.isActive; i < value; i += 1) {
        this.numbersPage.push(i);
      }
      return this.changeNumberPage(this.isActive);
    },
    changementRapidePrevious() {
      if (this.isActive === this.numbersPage[this.numberDisplay - 1]) {
        return this.changeNumberPage(this.numbersPage[0]);
      }
      this.changementNumbersPage((this.isActive - this.numberDisplay) + 1);
      return this.changeNumberPage(this.isActive);
    },
    changeNumberPage(newNumberPage) {
      if (this.isActive !== newNumberPage) {
        this.isActive = newNumberPage;
        this.$emit('changementPage', this.isActive);
      }
    },
  },
  mounted() {
    this.changementNumbersPage(this.firstNumber);
  },
};
</script>
